import React, { useMemo, useState } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Pagination,
  InputGroup,
  Form
} from 'react-bootstrap';

const BalReqHistory = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 8;
  const [searchQuery, setSearchQuery] = useState('');

  const requests = [
    {
      id: 'BRH001',
      date: '2024-11-05',
      time: '09:20 AM',
      amount: 25000,
      mode: 'UPI',
      utr: 'UPI24341ABC',
      status: 'Approved',
      approvedOn: '2024-11-05 10:05 AM',
      requestedBy: 'Rajesh Kumar',
      remarks: 'UPI settlement for daily float',
      attachment: 'upi-slip-001.pdf'
    },
    {
      id: 'BRH002',
      date: '2024-11-04',
      time: '05:40 PM',
      amount: 15000,
      mode: 'IMPS',
      utr: 'IMPS24451ZYX',
      status: 'Pending',
      approvedOn: '-',
      requestedBy: 'Priya Sharma',
      remarks: 'Awaiting confirmation from bank',
      attachment: 'imps-slip-014.pdf'
    },
    {
      id: 'BRH003',
      date: '2024-11-04',
      time: '01:30 PM',
      amount: 5000,
      mode: 'Cash',
      utr: 'CASH-24-1104-09',
      status: 'Rejected',
      approvedOn: '2024-11-04 02:10 PM',
      requestedBy: 'Anjali Gupta',
      remarks: 'Cash slip not clear in upload',
      attachment: 'cash-slip-009.jpg'
    },
    {
      id: 'BRH004',
      date: '2024-11-03',
      time: '11:05 AM',
      amount: 30000,
      mode: 'NEFT',
      utr: 'NEFT20241103002',
      status: 'Approved',
      approvedOn: '2024-11-03 01:45 PM',
      requestedBy: 'Rahul Verma',
      remarks: 'Branch top-up for weekend load',
      attachment: 'neft-slip-002.pdf'
    },
    {
      id: 'BRH005',
      date: '2024-11-02',
      time: '07:25 PM',
      amount: 12000,
      mode: 'UPI',
      utr: 'UPI24396LMN',
      status: 'Approved',
      approvedOn: '2024-11-03 09:00 AM',
      requestedBy: 'Neha Joshi',
      remarks: 'Evening settlement request',
      attachment: 'upi-slip-027.pdf'
    },
    {
      id: 'BRH006',
      date: '2024-11-02',
      time: '04:50 PM',
      amount: 8000,
      mode: 'IMPS',
      utr: 'IMPS24422PQR',
      status: 'Approved',
      approvedOn: '2024-11-02 06:10 PM',
      requestedBy: 'Suresh Yadav',
      remarks: 'Short-term fund requirement',
      attachment: 'imps-slip-021.pdf'
    },
    {
      id: 'BRH007',
      date: '2024-11-01',
      time: '03:15 PM',
      amount: 18000,
      mode: 'NEFT',
      utr: 'NEFT20241101011',
      status: 'Approved',
      approvedOn: '2024-11-01 05:05 PM',
      requestedBy: 'Pooja Singh',
      remarks: 'Monthly float top-up',
      attachment: 'neft-slip-011.pdf'
    },
    {
      id: 'BRH008',
      date: '2024-10-31',
      time: '12:05 PM',
      amount: 9000,
      mode: 'Cash',
      utr: 'CASH-24-1031-04',
      status: 'Approved',
      approvedOn: '2024-10-31 01:20 PM',
      requestedBy: 'Manoj Tiwari',
      remarks: 'Counter cash deposit',
      attachment: 'cash-slip-004.jpg'
    }
  ];

  const filteredRequests = useMemo(() => {
    if (!searchQuery) {
      return requests;
    }

    return requests.filter((request) =>
      Object.values(request).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  }, [requests, searchQuery]);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRequests = filteredRequests.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredRequests.length / rowsPerPage) || 1;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const formatCurrency = (value) => `₹${value.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

  const getPaginationItems = () => {
    const items = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        items.push(
          <Pagination.Item
            key={i}
            active={i === currentPage}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </Pagination.Item>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
        items.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
        items.push(
          <Pagination.Item
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </Pagination.Item>
        );
      } else if (currentPage >= totalPages - 2) {
        items.push(
          <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
            1
          </Pagination.Item>
        );
        items.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
        for (let i = totalPages - 3; i <= totalPages; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
      } else {
        items.push(
          <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
            1
          </Pagination.Item>
        );
        items.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
        items.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
        items.push(
          <Pagination.Item
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </Pagination.Item>
        );
      }
    }

    return items;
  };

  return (
    <Container fluid className="bal-req-history-page p-4">
      <Row>
        <Col>
          <Card className="shadow-sm border-0">
            <Card.Header className="bg-white border-bottom" style={{ padding: '16px 24px' }}>
              <Row className="align-items-center">
                <Col md={6}>
                  <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c2268' }}>
                    Balance Request History
                  </h5>
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                  <InputGroup style={{ maxWidth: '300px' }}>
                    <InputGroup.Text style={{ backgroundColor: '#f8f9fa', border: '1px solid #ddd' }}>
                      <i className="bi bi-search"></i>
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(1);
                      }}
                      style={{ border: '1px solid #ddd' }}
                    />
                  </InputGroup>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body className="p-0">
              <div className="table-responsive">
                <Table hover className="mb-0">
                  <thead style={{ backgroundColor: '#f8f9fa' }}>
                    <tr>
                      {[
                        'ID',
                        'Request_Date',
                        'Request_Time',
                        'Amount',
                        'Mode',
                        'UTR / Reference',
                        'Status',
                        'Approved_On',
                        'Requested_By',
                        'Remarks',
                        'Attachment'
                      ].map((column) => (
                        <th
                          key={column}
                          style={{
                            padding: '12px 16px',
                            fontWeight: 600,
                            color: '#555',
                            borderBottom: '2px solid #dee2e6',
                            fontSize: '13px'
                          }}
                        >
                          {column}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {currentRequests.length > 0 ? (
                      currentRequests.map((request) => (
                        <tr key={request.id} style={{ transition: 'background-color 0.2s' }}>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 600 }}>{request.id}</td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>{request.date}</td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>{request.time}</td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 600 }}>{formatCurrency(request.amount)}</td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>{request.mode}</td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontFamily: 'monospace' }}>{request.utr}</td>
                          <td style={{ padding: '12px 16px', color: request.status === 'Approved' ? '#198754' : request.status === 'Rejected' ? '#dc3545' : '#fd7e14', fontSize: '13px', fontWeight: 600 }}>
                            {request.status}
                          </td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>{request.approvedOn}</td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px' }}>{request.requestedBy}</td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', maxWidth: '220px' }}>
                            <details>
                              <summary style={{ cursor: 'pointer', fontWeight: 500 }}>View</summary>
                              <div style={{ marginTop: '8px', color: '#555' }}>{request.remarks}</div>
                            </details>
                          </td>
                          <td style={{ padding: '12px 16px', color: '#0d6efd', fontSize: '13px' }}>{request.attachment}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={11} className="text-center py-4" style={{ color: '#999' }}>
                          No balance requests found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
            <Card.Footer className="bg-white border-top" style={{ padding: '12px 24px' }}>
              <Row className="align-items-center">
                <Col md={6}>
                  <div style={{ fontSize: '14px', color: '#666' }}>
                    Showing {filteredRequests.length === 0 ? 0 : indexOfFirstRow + 1} to {Math.min(indexOfLastRow, filteredRequests.length)} of {filteredRequests.length}
                  </div>
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                  <Pagination className="mb-0">
                    <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                    <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                    {getPaginationItems()}
                    <Pagination.Next
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    />
                    <Pagination.Last
                      onClick={() => handlePageChange(totalPages)}
                      disabled={currentPage === totalPages}
                    />
                  </Pagination>
                </Col>
              </Row>
            </Card.Footer>
          </Card>
        </Col>
      </Row>

      <style jsx="true">{`
        .bal-req-history-page {
          background-color: #fff;
          min-height: calc(100vh - 100px);
        }

        .table tbody tr:hover {
          background-color: #f8f9fa;
        }

        .pagination .page-link {
          color: #0d6efd;
          border: 1px solid #dee2e6;
          padding: 6px 12px;
          font-size: 14px;
        }

        .pagination .page-item.active .page-link {
          background-color: #0d6efd;
          border-color: #0d6efd;
          color: white;
        }

        .pagination .page-link:hover {
          background-color: #e7f1ff;
          border-color: #0d6efd;
          color: #0d6efd;
        }

        .pagination .page-item.disabled .page-link {
          color: #6c757d;
          pointer-events: none;
          background-color: #fff;
          border-color: #dee2e6;
        }

        @media (max-width: 768px) {
          .table-responsive {
            overflow-x: auto;
          }

          .pagination {
            font-size: 12px;
          }
        }
      `}</style>
    </Container>
  );
};

export default BalReqHistory;


